var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{class:("axis-wrapper " + _vm.type)},[_c('g',{staticClass:"axis axis-x"}),(_vm.showLabel)?_c('text',{staticClass:"label",attrs:{"transform":("translate(" + (_vm.width/2) + ", 50)")}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }